import { gqlSubmissionStatusEnum as SUBMISSION_STATUS } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { useFeatureExperiment, FEATURE_FLAGS } from '@blocs.features-experiments';

export const useSubmissionStatusOptions = () => {
  const { t } = useTranslation();

  const isWorksheetSubmissionStatusEnabled = useFeatureExperiment(
    FEATURE_FLAGS.WEB_CASTING_WORKSHEET_SUBMISSION_STATUS_VALUES
  );

  const newFTVStatuses = [
    { value: SUBMISSION_STATUS.BACKUP, label: t('common:label.backup') },
    { value: SUBMISSION_STATUS.PINNED, label: t('common:label.pinned') },
    { value: SUBMISSION_STATUS.ON_HOLD, label: t('common:label.onHold') },
    { value: SUBMISSION_STATUS.RELEASED, label: t('common:label.released') },
  ];

  const allStatuses = [
    { value: SUBMISSION_STATUS.TO_REVIEW, label: t('common:label.unviewed') },
    { value: SUBMISSION_STATUS.REVIEWED, label: t('common:label.viewed') },
    { value: SUBMISSION_STATUS.SELECTED, label: t('common:label.selected') },
    { value: SUBMISSION_STATUS.UNDER_CONSIDERATION, label: t('common:form.label.underConsideration') },
    { value: SUBMISSION_STATUS.ON_AVAIL, label: t('common:label.onAvail') },
    { value: SUBMISSION_STATUS.BOOKED, label: t('common:label.booked') },
    ...(isWorksheetSubmissionStatusEnabled ? newFTVStatuses : []),
  ];

  if (!isWorksheetSubmissionStatusEnabled) return allStatuses;

  const customOrder = [
    SUBMISSION_STATUS.TO_REVIEW,
    SUBMISSION_STATUS.REVIEWED,
    SUBMISSION_STATUS.SELECTED,
    SUBMISSION_STATUS.UNDER_CONSIDERATION,
    SUBMISSION_STATUS.PINNED,
    SUBMISSION_STATUS.ON_AVAIL,
    SUBMISSION_STATUS.ON_HOLD,
    SUBMISSION_STATUS.BACKUP,
    SUBMISSION_STATUS.BOOKED,
    SUBMISSION_STATUS.RELEASED,
  ];

  // Sort based on the custom order
  return allStatuses.sort((a, b) => {
    return customOrder.indexOf(a.value) - customOrder.indexOf(b.value);
  });
};
